/** «Дни» обзвона — ровно то, что отдают `GET /api/deals/days` и `/api/deals/days/{date}`.
 * Спека `docs/specs/2026-09-26-dialing-days-design.md`. */
import { apiFetch } from "@/lib/api";
import type { CallType } from "@/lib/dialing";

export type Metrics = {
  deals: number;
  called: number;
  untouched: number;
  talked: number;
  no_answer: number;
  attempts: number;
  connected: number;
  talks: number;
  pending: number;
  moved: number;
  gone: number;
  rescheduled: number;
  /** Воронка попыток: 1-я, 2-я, 3-я и дальше — дошли без разговора, соединились, разговор. */
  funnel: Record<Attempt, { reached: number; connected: number; talked: number }>;
  /** Разговор на входящем раньше исходящих — клиент перезвонил сам. */
  talk_inbound: number;
};

export const ATTEMPTS = ["1", "2", "3+"] as const;
export type Attempt = (typeof ATTEMPTS)[number];

export type DayRow = {
  date: string;
  morning_at: string;
  evening_at: string | null;
  closed: boolean;
  evening: number | null;
  new: number | null;
  total: Metrics & { to: Record<string, number> };
  by_type: Record<string, Metrics & { to: Record<string, number> }>;
};

export type DaysList = { types: CallType[]; days: DayRow[] };

export type DayDeal = {
  id: number;
  type_id: number;
  stage_morning: string;
  stage_evening: string;
  moved: boolean;
  /** null — вечернего снимка ещё нет. */
  gone: boolean | null;
  attempts: number;
  connected: number;
  talks: number;
  pending: number;
  result: "talk" | "no_answer" | "untouched";
  /** До какой исходящей попытки дошли (до разговора включительно). */
  reached: number;
  connect_at: number | null;
  /** Попытка с разговором; 0 — разговор на входящем, null — разговора не было. */
  talk_at: number | null;
  last_call_at: string | null;
  user: string;
  callers: string[];
};

export type DayCard = {
  date: string;
  morning_at: string;
  evening_at: string | null;
  closed: boolean;
  evening: number | null;
  new: number | null;
  types: CallType[];
  total: Metrics & { to: Record<string, number> };
  by_type: (Metrics & { type_id: number; name: string; to: Record<string, number> })[];
  users: { bitrix_user_id: number; name: string; deals: number; attempts: number; connected: number; talks: number; moved: number }[];
  hours: { hour: number; attempts: number; talks: number; moves: number }[];
  deals: DayDeal[];
  stages: Record<string, string>;
};

export function loadDays(): Promise<DaysList> {
  return apiFetch<DaysList>("/api/deals/days");
}

export function loadDay(day: string): Promise<DayCard> {
  return apiFetch<DayCard>(`/api/deals/days/${day}`);
}

/** Доля от когорты, «—» без знаменателя. */
export const pct = (n: number, of: number) => (of ? `${Math.round((n / of) * 100)}%` : "—");

/** Звонки с разговором по сделкам когорты дня — раздел «Звонки» (`?dialing=`). */
export const talkCallsUrl = (day: string, type: number | null) =>
  `/calls?tab=list&from=${day}&dialing=${day}${type === null ? "" : `&dtype=${type}`}&talk=talk`;
